import React, { lazy, Suspense } from 'react';

import { Route, type RouteObject, Routes } from 'react-router-dom';

import { Spinner } from '@pkg/components';
import { useAppSelector } from '@pkg/hooks';

import {
    FeatureRoutes,
    GROUP_INVITE_FREE_YAT,
    GROUP_INVITE_WELCOME,
    GROUP_SINGLE,
    GROUP_SINGLE_INVITE_ACCEPT,
    GROUP_SINGLE_MEMBERS,
} from '@app/routes';
import { useSentryRoutes } from '@app/routes/hooks/useSentryRoutes';

const PageNotFound = lazy(() => import('@app/pages/PageNotFound').then((m) => ({ default: m.PageNotFound })));
const Pods = lazy(() => import('@app/pages/Pods/Pods'));
const Group = lazy(() => import('@app/pages/Groups/Group').then((m) => ({ default: m.Group })));
const GroupInvitesFreeYat = lazy(() => import('@app/pages/Groups/invites/FreeYat'));

const podDetailRoutes: RouteObject[] = [
    GROUP_SINGLE,
    GROUP_SINGLE_MEMBERS,
    GROUP_INVITE_WELCOME,
    GROUP_SINGLE_INVITE_ACCEPT,
].map((path) => ({ path, element: <Group /> }));

const podRouteFilterPath: RouteObject[] = ['following', 'trending', 'popular', 'my_pods'].map((path) => ({
    path,
    element: <Pods />,
}));

function PodDetailsSectionRoutes() {
    const podInviteAcceptFlow = useAppSelector((state) => state.featureFlags.features.podInviteAcceptFlow);
    const podRoutes = [
        {
            index: true,
            element: <Pods />,
        },
        ...podRouteFilterPath,
        {
            element: <FeatureRoutes feature={podInviteAcceptFlow} />,
            children: [{ path: GROUP_INVITE_FREE_YAT, element: <GroupInvitesFreeYat /> }],
        },
        ...podDetailRoutes,
        {
            path: '*',
            elemet: <PageNotFound />,
        },
    ];
    const sections = useSentryRoutes(podRoutes);
    return <Suspense fallback={<Spinner />}>{sections}</Suspense>;
}
export const PodRoutes = () => {
    return (
        <Routes>
            <Route index element={<Pods />} />
            <Route path="*" element={<PodDetailsSectionRoutes />} />
        </Routes>
    );
};
